import { useCallback, useSyncExternalStore } from 'react';

/**
 * Vero su schermi da tablet in su.
 *
 * La soglia e' la stessa dei fogli di stile: tenerne una sola evita il caso in
 * cui il CSS mostra la barra laterale e il codice crede di essere sul
 * telefono.
 *
 * Implementato con `useSyncExternalStore` e non con `useState` piu'
 * `useEffect`: quest'ultimo legge la larghezza al primo render e si iscrive
 * agli aggiornamenti solo dopo: se lo schermo cambia in quel mezzo — una
 * rotazione, una finestra ridimensionata, un ridimensionamento programmatico —
 * quel cambiamento si perde e il componente resta convinto di una larghezza
 * che non e' piu' vera. `useSyncExternalStore` rilegge il valore alla
 * sottoscrizione, quindi non c'e' finestra in cui possa restare disallineato.
 */
export const SOGLIA_SCHERMO_LARGO = 768;

const QUERY = `(min-width: ${SOGLIA_SCHERMO_LARGO}px)`;

export function useSchermoLargo(): boolean {
  const sottoscrivi = useCallback((notifica: () => void) => {
    const query = window.matchMedia(QUERY);
    query.addEventListener('change', notifica);
    return () => query.removeEventListener('change', notifica);
  }, []);

  const leggi = useCallback(() => window.matchMedia(QUERY).matches, []);

  // Il terzo argomento vale durante il rendering sul server, dove `window` non
  // esiste: si assume lo schermo stretto, che e' il caso piu' comune.
  return useSyncExternalStore(sottoscrivi, leggi, () => false);
}
